<template>
    <div class="dataview">
        <div class="tips">
            想看我的个人保单？试试保单托管？
            <span class="try">点我尝试</span>
        </div>
        <el-form ref="form" :model="searchForm" :inline="true" label-position="left">
            <el-form-item label="投保年度：">
                <el-select>
                    <el-option>1</el-option>
                    <el-option>2</el-option>
                    <el-option>3</el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                 <el-button type="primary">查询</el-button>
            </el-form-item>
        </el-form>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>2020年度</span>
            </div>
            <div >
               <el-row :getter='12'>
                   <el-col :span="8" class="center">
                       <p>￥1,000,000</p>
                       <p>保单契约投入</p>
                   </el-col>
                   <el-col :span="8" class="center">
                        <p>10</p>
                       <p>投保保单（张）</p>
                   </el-col>
                   <el-col :span="8" class="center">
                        <p>30</p>
                       <p>投保公司（家）</p>
                   </el-col>
               </el-row>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.dataview{
    padding: 33px;
    .tips{
        height:54px;
        background:rgba(255,251,239,1);
        border:1px solid rgba(243,238,222,1);
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(85,85,90,1);
        line-height:54px;
        padding:0 24px;
        margin:20px 0 ;
        .try{
            color: #5788BB;
            text-decoration:underline;
            cursor: pointer;
            text-align: right;
            float: right;
        }
    }
    .box-card{
        .center{
            text-align: center;
            :nth-child(1){
               font-size:20px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(226,124,0,1);
                line-height:20px; 
            }
            :nth-child(2){
                margin-top: 8px;
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(85,85,90,1);
                line-height:16px;
            }
        }
    }
}
</style>